import React, { FC } from 'react';
import { Card, Spin } from 'antd';

require('./EditPage.less');

export const EditPage: FC<any> = ({ title, fetching, FormComponent, formComponentProps }) => {
	return fetching ? (
		<div
			style={{
				minHeight: '100vh',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<Spin size="large" />
		</div>
	) : (
		<div style={{ margin: '24px 24px 0' }}>
			{title ? <h4 style={{ marginBottom: 24 }}>{title}</h4> : null}
			<Card bordered={false}>
				<FormComponent {...formComponentProps} />
			</Card>
		</div>
	);
};
